// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"AppLoader_loader-container__Vo9fv","spinner":"AppLoader_spinner__j3mvl","spinning":"AppLoader_spinning__JuXad"};